import React from "react";
import { Grid, Box, Stack } from "@mui/material";
import MKTypography from "components/MKTypography";
import HeaderContainer from "styles/components/headerContainer";

import { StyledSectionContainer } from "styles/components/SectionContainer/index.styles";
import { StyledAboutKetamineCards } from "index.styles";
import { useTheme } from "@emotion/react";
import DevicesIcon from "@mui/icons-material/Devices";
import RouteIcon from "@mui/icons-material/Route";
import VerifiedIcon from "@mui/icons-material/Verified";
import SecurityIcon from "@mui/icons-material/Security";
// import useMediaQueries from "utils/mediaQueries.utils";

const icons = {
  DevicesIcon: <DevicesIcon />,
  RouteIcon: <RouteIcon />,
  VerifiedIcon: <VerifiedIcon />,
  SecurityIcon: <SecurityIcon />,
};

const FourColumnSection = ({
  title,
  description,
  items = [],
  cta,
  columnGap = { xs: 2, md: 4 },
  rowGap = { xs: 2, md: 4 },
  cssProps = {},
  highlightText,
  highlightColor,
  cardCssProps,
  ...props
}) => {
  const theme = useTheme();
  // const { isLg, isMd } = useMediaQueries();
  return (
    <StyledSectionContainer sx={cssProps} {...props}>
      {/* Header Section */}
      {(title || description) && (
        <Box sx={{ mb: { xs: 4, md: 6 } }}>
          {title && (
            <HeaderContainer
              title={title}
              component="h2"
              highlightText={highlightText}
              highlightColor={highlightColor || theme.palette.accent.main}
              variant="h2"
              textColor="#092860"
              cssProps={{
                margin: "0rem 0rem 2rem 0rem !important",
              }}
            />
          )}
        </Box>
      )}

      {/* Four Column Items */}
      {items.length > 0 && (
        <Grid container rowSpacing={rowGap} columnSpacing={columnGap} justifyContent="center" alignItems="stretch">
          {items.map((item, index) => (
            <Grid item xs={item.grid?.xs || 12} md={item.grid?.md || 6} lg={item.grid?.lg || 6} key={index} sx={cardCssProps}>
              <StyledAboutKetamineCards sx={cardCssProps}>
                <Stack direction="column" alignItems="center" spacing={3} sx={{ height: "100%" }}>
                  {/* Icon */}
                  {item.icon && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: { xs: "70px" },
                        height: { xs: "70px" },
                        borderRadius: "20px",
                        overflow: "hidden",
                        flexShrink: 0,
                      }}
                    >
                      {item.icon.iconName && (
                        <span
                          style={{
                            fontSize: "2.5rem",
                            color: theme.palette.accent.main,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {icons[item.icon.iconName]}
                        </span>
                      )}
                      {item.icon?.src && (
                        <Box
                          component="img"
                          src={item.icon.src}
                          alt={item.icon.alt}
                          sx={{
                            width: { xs: "40px" },
                            height: { xs: "40px" },
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </Box>
                  )}

                  {/* Content */}
                  <Stack sx={{ flex: 1 }}>
                    {item.title && (
                      <MKTypography
                        variant="h6"
                        component="h3"
                        sx={{
                          fontWeight: 600,
                          mb: 1,
                        }}
                      >
                        {item.title}
                      </MKTypography>
                    )}
                    {(item.description || item.content) && (
                      <MKTypography
                        variant={"body2"}
                        component="p"
                        sx={{
                          opacity: 0.7,
                          lineHeight: 1.5,
                          minHeight: { lg: "72px" },
                        }}
                      >
                        {item.description || item.content}
                      </MKTypography>
                    )}
                  </Stack>
                </Stack>
              </StyledAboutKetamineCards>
            </Grid>
          ))}
        </Grid>
      )}
    </StyledSectionContainer>
  );
};

export default FourColumnSection;
